<template>
    <div class="container-progress-circular">
        <div class="circular-progress">
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
        data() {
            return {
                progressBar: null,
                progressEndValue: 60,
                speed: 1000,
                progress: null,
                progressStatus: this.progressEnabled
            }
        },
        mounted() {
            this.start_progress()
        },
        methods: {
            start_progress() { 
                this.progressBar = document.querySelector(".circular-progress")
                this.progress = setInterval(() => {
                    if(this.progressEnabled == true){
                        this.$store.dispatch('progressValue', this.progressValue + 1)
                        this.progressBar.style.background = `conic-gradient(
                            #000000 ${this.progressValue * 6}deg,
                            #b3b3b3 ${this.progressValue * 6}deg
                        )`;
                        if (this.progressValue == this.progressEndValue) {
                            this.progressBar.style.background = `#001CCF`;
                            clearInterval(this.progress);
                            this.$emit('enableButton')
                            this.$store.dispatch('progressValue', 0);
                        }else if(this.progressValue > this.progressEndValue) {
                            clearInterval(this.progress);
                            this.progressBar.style.background = `#001CCF`;
                            this.$emit('enableButton')
                        }
                    }
                },this.speed)
            },
            end_progress() {
                this.progressBar = document.querySelector(".circular-progress")
                this.progressBar.style.background = `#001CCF`;
                clearInterval(this.progress);
                this.progressEnabled = false;
                this.$emit('enableButton')
                this.$store.dispatch('progressValue', 0);
            }
        },
        computed: {
          ...mapState({            
            progressValue: state => state.progressValue,
            progressEnabled: state => state.progressEnabled
          })
        }
    }
</script>

<style>
    @media (min-width: 768px) {
        .container-progress-circular{
            margin-left: 35% !important;
        }
    }
    .container-progress-circular {
        margin-right: 20px; 
        margin-left: 65px;
        position: relative;
        display: contents;
    }
    .circular-progress{
        height: 13px;
        width: 13px;
        padding: 2px;
        background: #b3b3b3;
        border-radius: 50%;
        top: 17px;
        display: inline-grid;
        place-items: center;
        margin-right: 10px;
    }
  
    .circular-progress::before{
        content: "";
        position: inherit;
        height: 89%;
        width: 89%;
        background-color: #ffffff;
        border-radius: 50%;
    }
</style>